module.exports = __webpack_public_path__ + "static/img/bloomberg.a7ba880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/old/bloomberg.png
// module id = MuFU
// module chunks = 0